import { Component, OnInit, ViewContainerRef } from '@angular/core';
import { environment } from '../../../environments/environment';
import { Product } from '../../models/product';
import { AlgGtmService } from '../../services/alg-gtm.service';
import { ApiService } from '../../services/api.service';
import { UtilsService } from '../../services/utils.service';
import { StopOnboardingModalComponent } from '../../components/dialogs/stop-onboarding-modal/stop-onboarding-modal.component';
import { ModalDialogService, SimpleModalComponent, IModalDialogButton } from 'ngx-modal-dialog';

@Component({
  selector: 'alg-header',
  templateUrl: './alg-header.component.html',
  styleUrls: ['./alg-header.component.scss']
})
export class AlgHeaderComponent implements OnInit {
  public currentOnBoarding: any;
  public isSaveAvailable = false;
  public websiteUrl: string = environment.websiteUrl;
  public product: Product = {} as Product;

  constructor(private api: ApiService, private gtm: AlgGtmService,private utils: UtilsService, private modalDialogService: ModalDialogService, private viewContainer: ViewContainerRef) {
    this.api.currentProduct.subscribe(product => (this.product = product));
  }

  progresses = {
    init: 0,
    document: 0,
    user_info: 20,
    contract_info: 50,
    supplies: 75,
    payment: 90,
    summary: 100
  };

  public progress = 0;
  public restartOnboarding(){
    this.gtm.submitOnbEvent('Click su Cancella tutto');
    window.location.href = `${window.location.origin}/?prd=${this.product.slug}`;
  }

  ngOnInit() {
    this.api.currentOnboarding.subscribe(currentOnBoarding => {
      this.currentOnBoarding = currentOnBoarding;
      this.progress = this.progresses[currentOnBoarding.webStatus];
      this.isSaveAvailable = this.currentOnBoarding.email && this.currentOnBoarding.email.length > 0  && true;
    });
  }

  openModal() {
    this.utils.disableOverflow();
    if(this.isSaveAvailable){
      const data = {...this.currentOnBoarding};
      data.sendEmail = true;
      this.api.saveOnboarding(data, true);
      this.modalDialogService.openDialog(this.viewContainer, {
        title: 'Salva e Sospendi',
        childComponent: StopOnboardingModalComponent,
        settings: {
          closeButtonClass: 'close theme-icon-close'
        },
        data: {
          text: ''
        }
      });
    }
  }

}



// WEBPACK FOOTER //
// ./src/app/components/alg-header/alg-header.component.ts